const isOnSale = (product) => {
  if (!product) return false
  return product.price && 
    product.special_price && 
    product.special_price > 0 && 
    product.special_price < product.price
}

export default isOnSale
